// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__38FoN","sendOtp":"AuthorizeToLogin_sendOtp__2M7aQ"};